import React from 'react';
import '../../styles/PursueMBA.css';
import { pin, PursueMBA1, PursueMBA2, PursueMBA3, PursueMBA4 } from '../../assets/index';

const PursueMBA = () => {
  return (
    <>
      <div className="mba-container1 relative w-full  px-4 sm:px-6 lg:px-8">
        <div className="head_container relative">
          <div className="line relative top-[2.7rem] w-full"></div>
          <h1 className="title animate-fade-in relative top-[3.2rem] text-2xl sm:text-3xl md:text-4xl lg:text-6xl text-center">
            Pursue a Practical MBA
          </h1>
          <div className='relative lg:right-[1.5rem] md:right-[5rem] sm:right-[10rem]'>
            <p className="subtitle animate-fade-in relative left-0 sm:left-[12rem] md:left-[15rem] top-[2.5rem] flex items-center justify-center sm:justify-start">
              <img 
                src={pin} 
                alt="Pin Icon" 
                className="pImg relative sm:right-[7rem] right-1 md:right-[1rem] lg:right-[2rem] w-5 sm:w-6" 
              />
              <span className="text-sm sm:text-base md:text-lg md:w-[20rem]">
                A career that fulfills you and makes a difference is possible with us
              </span>
            </p>
          </div>
        </div>

        <div className="content w-full px-2 sm:px-4 md:px-6 lg:px-8 mt-16 sm:mt-20 relative top-[5rem]">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 justify-items-center">
            {/* Card 1 */}
            <div className="w-[90%] sm:w-[16rem] md:w-[18rem] h-full card bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 sm:p-4 md:p-6 flex flex-col">
              <img
                src={PursueMBA1}
                alt="Affordable MBA Icon"
                className="icon uicon w-10 sm:w-12 md:w-16 h-auto mx-auto mb-3"
              />
              <h3 className="header_text text-center flex-grow text-sm sm:text-base md:text-lg lg:text-xl font-semibold">
                Affordable MBA Pursuit at Dr. D.Y. Patil Vidyapeeth
              </h3>
              <p className="header_subtitle text-center mt-2 text-xs sm:text-sm md:text-base">
                UGC recognized & NAAC, AICTE, ASSOCHAM, AIU, & WES accredited.
              </p>
            </div>

            {/* Card 2 */}
            <div className="w-[90%] sm:w-[16rem] md:w-[18rem] h-full card bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 sm:p-4 md:p-6 flex flex-col">
              <img
                src={PursueMBA2}
                alt="Certifications Icon"
                className="icon uicon w-10 sm:w-12 md:w-16 h-auto mx-auto mb-3"
              />
              <h3 className="header_text text-center flex-grow text-sm sm:text-base md:text-lg lg:text-xl font-semibold">
                Corporate Industry Recognized 15+ Core Finance Certifications
              </h3>
            </div>

            {/* Card 3 */}
            <div className="w-[90%] sm:w-[16rem] md:w-[18rem] h-full card bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 sm:p-4 md:p-6 flex flex-col">
              <img
                src={PursueMBA3}
                alt="Job Experience Icon"
                className="icon uicon w-10 sm:w-12 md:w-16 h-auto mx-auto mb-3"
              />
              <h3 className="header_text text-center flex-grow text-sm sm:text-base md:text-lg lg:text-xl font-semibold">
                Obtain 1 year Job experience in Finance recognized by FINXL BUSINESS SCHOOL
              </h3>
            </div>

            {/* Card 4 */}
            <div className="w-[90%] sm:w-[16rem] md:w-[18rem] h-full card bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 p-3 sm:p-4 md:p-6 flex flex-col">
              <img
                src={PursueMBA4}
                alt="Business Professionals Icon"
                className="icon uicon w-10 sm:w-12 md:w-16 h-auto mx-auto mb-3"
              />
              <h3 className="header_text text-center flex-grow text-sm sm:text-base md:text-lg lg:text-xl font-semibold">
                Transforming students into business management professionals
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PursueMBA;